import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL,
  ONLINE_STORE_CLOSE_DISCONNECT_SHOP_MODAL,
} from 'actions/onlineStore/constants';

const selectedShop = createReducer(null, {
  [ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL]: (draft, { payload }) =>
    payload.shop,
});

const selectedOutlet = createReducer(null, {
  [ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL]: (draft, { payload }) =>
    payload.outlet,
});

const show = createReducer(false, {
  [ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_DISCONNECT_SHOP_MODAL]: () => false,
});

export default combineReducers({
  show,
  selectedShop,
  selectedOutlet,
});
